import { useEffect } from "react";
import {
  MdCheckCircle,
  MdError,
  MdWarning,
  MdClose,
} from "react-icons/md";

export default function Alert({
  type = "success",
  message,
  onClose,
  autoClose = false,
  duration = 4000,
}) {
  useEffect(() => {
    if (!autoClose || !onClose || !message) return;

    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [autoClose, duration, onClose, message]);

  if (!message) return null; 

  const config = {
    success: {
      icon: <MdCheckCircle className="text-green-600" size={22} />,
      classes: "bg-green-50 border-green-400 text-green-800",
    },
    error: {
      icon: <MdError className="text-red-600" size={22} />,
      classes: "bg-red-50 border-red-400 text-red-800",
    },
    warning: {
      icon: <MdWarning className="text-yellow-600" size={22} />,
      classes: "bg-yellow-50 border-yellow-400 text-yellow-800",
    },
  };

  const { icon, classes } = config[type];

  return (
    <div
      className={`mb-4 flex items-start gap-3 rounded-xl border-l-4 px-5 py-4 shadow-sm ${classes}`}
    >
      <div className="mt-0.5">{icon}</div>

      <div className="flex-1 text-sm font-medium leading-relaxed">
        {message}
      </div>

      {onClose && (
        <button
          onClick={onClose}
          className="ml-2 rounded-full p-1 text-gray-500 hover:bg-black/10 hover:text-black transition"
        >
          <MdClose size={16} />
        </button>
      )}
    </div>
  );
}
